import { call, put } from 'redux-saga/effects';

import api from 'api';
import { IUserProfileResponse } from 'api/components/User/types';

import { notifyError, notifySuccess } from 'store/notifications/actions';
import { updateUserError, updateUserRequest, updateUserSuccess } from 'store/user/actions';

import { setIdToTheProvider } from 'services/Analytics/helpers';

import { getBirthdayByAge } from 'helpers/date';

export function* updateUser({ payload: { payload, onSuccess, onError } }: ReturnType<typeof updateUserRequest>) {
    try {
        const { age, ...restUserData } = payload;

        const userData: IUserProfileResponse = yield call(api.user.update, {
            ...restUserData,
            date_of_birth: age && getBirthdayByAge(age),
        });

        yield call(setIdToTheProvider, userData.id);

        yield put(updateUserSuccess(userData));
        yield put(notifySuccess({ message: 'message.success.changesSaved' }));

        if (onSuccess) yield call(onSuccess);
    } catch (error: any) {
        yield put(updateUserError({ error: error.message }));
        yield put(notifyError({ message: 'message.error.changesNotSaved' }));

        if (onError) yield call(onError);
    }
}
